import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Dropdown,
  Menu,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Badge,
  Select,
  Space,
  Switch,
  Tooltip,
  Tree,
  Modal,
  Avatar,
  Upload,
  Pagination,
  Table
} from 'antd';
import { usePageData } from '../../../hooks/usePage';
import { IPageData } from '../../../interfaces/page';
import {
  EditOutlined,
  DeleteOutlined,
  UploadOutlined,
  DownloadOutlined,
  UserOutlined
} from '@ant-design/icons';
import generalesProvider from '../../../services/generalesProvider';
import { Divider } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import './regdocumentos.css';
import gestionDocumentosProvider from '../../../services/gestiondocumentos';
import { saveAs } from 'file-saver';
import jwt_decode from 'jwt-decode';
const moment = require('moment');
const { Option } = Select;
const { Search } = Input;
const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Administración de Documentos',
      route: 'administracion-documentos'
    },
    {
      title: 'Registro de Documentos'
    }
  ]
};
const { Meta } = Card;
const { DirectoryTree } = Tree;
const key = 'regitrando';
interface FiltroHistorialDocumentos {
  id: number;
}
const GestionRegDocumentos = () => {
  usePageData(pageData);
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 8
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 16
      }
    }
  };
  const [filtroHistorialDocumentos, setFiltroHistorialDocumentos] =
    useState<FiltroHistorialDocumentos>({ id: 0 });
  const [formModalDirectorio] = Form.useForm();
  const [formFile] = Form.useForm();
  const [state, setState] = useState<{
    rightClickNodeTreeItem: {
      pageX: '';
      pageY: '';
      id: '';
      categoryName: '';
      padre: 0;
      idsusuariocompartidos: '';
      nombredocumento: '';
    };
  }>(null);
  const [data, setData] = useState({ data: [], totalRecords: 0 });
  const [isModalHistorialDocumentosVisible, setisModalHistorialDocumentosVisible] = useState(false);
  const [isModalCrearDirectorioVisible, setIsModalCrearDirectorioVisible] = useState(false);
  const [showContainerDirectorio, setShowContainerDirectorio] = useState<
    boolean | { showLeafIcon: boolean }
  >(false);
  const [showContainerFile, setShowContainerFile] = useState<boolean | { showLeafIcon: boolean }>(
    false
  );
  const [stateTree, setStateTree] = useState<any>({
    expandedKeys: [],
    searchValue: '',
    autoExpandParent: true
  });
  const [listTreePlano, setlistTreePlano] = useState<any>([]);
  const [listTree, setlistTree] = useState<any>([]);
  const [listDocumentos, setListDocumentos] = useState([]);
  const [adjuntos, setadjuntos] = useState([]);
  const [listCategoria, setListCategoria] = useState<any>([]);
  const [listAprobadores, setListAprobadores] = useState<any>([]);
  const { searchValue, expandedKeys, autoExpandParent } = stateTree;
  const [listAprobadoresAutoComplete, setListAprobadoresAutoComplete] = useState<any>([]);
  const [current, setCurrent] = useState(1);
  const [idArchivo, setIdArchivo] = useState(0);
  const [estadoDocumento, setEstadoDocumento] = useState('');
  const [titleDirectorio, setTitleDirectorio] = useState('');
  const [isDisabledControlesDocumentos, setisDisabledControlesDocumentos] = useState(false);
  const pageSize = 3;
  const PaginacionPersonalizada = ({ total, onChange, current }) => {
    return (
      <Pagination
        onChange={onChange}
        simple={true}
        total={total}
        current={current}
        pageSize={pageSize}
      />
    );
  };
  const columns = [
    {
      title: 'Nombre Documento',
      dataIndex: 'nombredocumento',
      key: 'nombredocumento',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Versión Documento',
      dataIndex: 'versiondocumento',
      key: 'versiondocumento',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Proceso',
      dataIndex: 'proceso',
      key: 'proceso',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Dirección',
      dataIndex: 'direccion',
      key: 'direccion',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Area',
      dataIndex: 'area',
      key: 'area',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },

    {
      title: 'Responsable',
      dataIndex: 'responsable',
      key: 'responsable',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Ubicación',
      dataIndex: 'ubicacion',
      key: 'ubicacion',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Estado',
      dataIndex: 'descripcionEstado',
      key: 'descripcionEstado',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Acción',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size='middle'>
            <Button
              size='small'
              type='primary'
              onClick={(e) => btnDescargarHistorialDocumento(text.id)}
            >
              Descargar Adjuntos
            </Button>
          </Space>
        );
      },
      align: 'center' as 'center'
    }
  ];
  const btnDescargarHistorialDocumento = async (id) => {
    const responsemodelo: any = await gestionDocumentosProvider.obtenerAdjuntoModel({ id: id });
    const response = await gestionDocumentosProvider.obtenerAdjunto(id);
    saveAs(response, responsemodelo.nombrearchivo);
  };
  const listarArchivos = async () => {
    if (filtroHistorialDocumentos.id !== 0) {
      const paginacion = {
        pagenum: current,
        pagesize: pageSize,
        id: filtroHistorialDocumentos.id
      };
      const res: any = await gestionDocumentosProvider.ListarHistorialArchivoPaginado(paginacion);
      if (res.data) setData(res);
    }
  };
  const onVerHistorial = useCallback(
    (values) => {
      var id = values.getFieldValue('id') === undefined ? '0' : values.getFieldValue('id');
      setFiltroHistorialDocumentos({ id: id });
      setisModalHistorialDocumentosVisible(true);
    },
    [formFile]
  );
  const IsModalHistorialDocumentoCancel = () => {
    setisModalHistorialDocumentosVisible(false);
  };
  useEffect(() => {
    listarArchivos();
  }, [filtroHistorialDocumentos]);

  useEffect(() => {
    listarArchivos();
  }, [current]);
  //#region metodo de tree
  const obtenerListaValor = async () => {
    const resAprobadores: any = await gestionDocumentosProvider.ObtenerAprobadores();
    if (resAprobadores.succeeded) {
      setListAprobadores(resAprobadores.data);
      if (resAprobadores.data.length > 0) {
        var listChildrenAprobadores = [];
        resAprobadores.data.forEach((element, index) => {
          listChildrenAprobadores.push(
            <Option value={element.usuarioId} key={index}>
              {element.nombreCompleto}
            </Option>
          );
        });
        setListAprobadoresAutoComplete(listChildrenAprobadores);
      }
    }
    const categorias = await generalesProvider.ObtenerListaValorPorSkeyCab({
      skeycab: 'SKEYCATEGORIAGESTIONDOCUMENTO'
    });
    setListCategoria(categorias);
  };

  useEffect(() => {
    obtenerListaValor();
  }, []);
  const onChangeTree = (e) => {
    const { value } = e.target;
    const expandedKeys = listTreePlano
      .map((item) => {
        if (item.nombredocumento.toLowerCase().indexOf(value.toLowerCase()) > -1) {
          return getParentKey(item.keytree, listTree);
        }
        return null;
      })
      .filter((item, i, self) => {
        return item && self.indexOf(item) === i;
      });
    setStateTree({
      expandedKeys,
      searchValue: value,
      autoExpandParent: true
    });
  };
  const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key;
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children);
        }
      }
    }
    return parentKey;
  };

  const obtenerArchivosTreeView = async () => {
    const res: any = await gestionDocumentosProvider.obtenerArchivosTreeView();
    if (res.succeeded) {
      setlistTree([]);
      setlistTreePlano([]);
      var listArbol = ArbolOpciones(res.data, null);
      setlistTree(listArbol);
      setlistTreePlano(res.data);
    }
  };
  const descargar = async (data) => {
    const responsemodelo: any = await gestionDocumentosProvider.obtenerAdjuntoModel({
      id: data.id
    });
    const response = await gestionDocumentosProvider.obtenerAdjunto(data.id);
    saveAs(response, responsemodelo.nombrearchivo);
  };
  const ArbolOpciones = (list, padre) => {
    return list
      .filter((x) => {
        return x.padre == padre;
      })
      .map((x) => ({
        title: x.nombredocumento,
        key: x.keytree,
        icon: x.icontree == false ? null : <FileOutlined />,
        id: x.id,
        padre: x.padre,
        children: ArbolOpciones(list, x.id),
        idsusuariocompartidos: x.idsusuariocompartidos,
        disabled: x.disabled
      }));
  };
  useEffect(() => {
    obtenerArchivosTreeView();
  }, []);
  const onSelect = async (selectedKeys: React.Key[], info: any) => {
    const res = await gestionDocumentosProvider.ObtenerArchivosPorId({ id: info.node.id });
    setListDocumentos(res.data);
    if (info.node.children.length === 0 && info.node.icon !== null) {
      /* Es un archivo */
      const archivo = res.data[0];
      setIdArchivo(archivo.id);
      setEstadoDocumento(archivo.descripcionEstado);
      // if (archivo.estado == 1) { //Pendiente
      //     setisDisabledControlesDocumentos(false);
      // } else if (archivo.estado == 2) { //Aprobado
      //     setisDisabledControlesDocumentos(true);
      // }
      formFile.setFieldsValue({
        id: archivo.id,
        nombredocumento: archivo.nombredocumento,
        codigodocumento: archivo.codigodocumento,
        versiondocumento: archivo.versiondocumento,
        idcategoria: archivo.idcategoria,
        //idaprobador: archivo.idaprobador === 0 || archivo.idaprobador === null ? null : archivo.idaprobador,
        proceso: archivo.proceso,
        direccion: archivo.direccion,
        area: archivo.area,
        responsable: archivo.responsable,
        ubicacion: archivo.ubicacion
      }); //seteamos el

      if (archivo.idaprobador !== 0) {
        formFile.setFieldsValue({ idaprobador: archivo.idaprobador }); //seteamos el
      }
      setShowContainerDirectorio(false);
      setShowContainerFile(true);
    } else {
      /* Es un directorio */
      setIdArchivo(0);
      setShowContainerDirectorio(true);
      setShowContainerFile(false);
    }
  };
  const InsertNodeInTree = (nodekey, object, listTreeLocal) => {
    listTreeLocal.forEach((element) => {
      if (element.key == nodekey) {
        if (element.children !== undefined) {
          /* Tiene hijos */
          var s = element.children.sort().reverse()[0]; // ordenamos los rgistros desc y obtener el valor de la primera posicion
          var a = parseInt(s.key.split('_')[s.key.split('_').length - 1]) + 1; // obtenemos el valor de la ultima posicion para sunmarle + 1
          var t = s.key.split('_');
          t.pop();
          object.key = t.join('_') + '_' + a;
        } else {
          /*No tiene hijo */
          object.key = nodekey + '_' + 1;
          element.children = [];
        }
        element.children.push(object);
      } else {
        if (element.children !== undefined) InsertNodeInTree(nodekey, object, element.children);
      }
    });
    setlistTree(listTreeLocal);
  };

  const getObjectGenerateNodeInTree = (nodekey, object, listTreeLocal) => {
    listTreeLocal.forEach((element) => {
      if (element.key == nodekey) {
        //if (element.children !== undefined) {/* Tiene hijos */
        if (element.children.length > 0) {
          /* Tiene hijos */
          var s = element.children.sort().reverse()[0]; // ordenamos los rgistros desc y obtener el valor de la primera posicion
          var a = parseInt(s.key.split('_')[s.key.split('_').length - 1]) + 1; // obtenemos el valor de la ultima posicion para sunmarle + 1
          var t = s.key.split('_');
          t.pop();
          object.key = t.join('_') + '_' + a;
        } else {
          /*No tiene hijo */
          object.key = nodekey + '_' + 1;
          element.children = [];
        }
        element.children.push(object);
      } else {
        if (element.children !== undefined)
          getObjectGenerateNodeInTree(nodekey, object, element.children);
      }
    });
    return object;
  };

  const onExpand = (expandedKeys) => {
    setStateTree({
      searchValue: '',
      expandedKeys,
      autoExpandParent: false
    });
  };
  //#endregion

  //#region metodo de Context Menu
  const onRightClick = (info: { event: any; node: any }) => {
    if (info.node.disabled === false) {
      setState({
        rightClickNodeTreeItem: {
          pageX: info.event.pageX.toString(),
          pageY: info.event.pageY.toString(),
          id: info.node.key,
          padre: info.node.id,
          categoryName: info.node.title,
          idsusuariocompartidos: info.node.idsusuariocompartidos,
          nombredocumento: info.node.nombredocumento
        }
      });
    }
  };
  const handleClick = () => {
    setState(null);
  };
  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.addEventListener('click', handleClick);
    };
  });
  const getNodeTreeRightClickMenu = () => {
    if (state == null) return '';
    else {
      const { pageX, pageY, id, categoryName, padre, idsusuariocompartidos, nombredocumento } = {
        ...state.rightClickNodeTreeItem
      };
      const tmpStyle: any = {
        position: 'absolute',
        left: `${parseFloat(pageX) - 220}px`,
        top: `${parseFloat(pageY) - 74}px`,
        zIndex: 2
      };

      const menu = (
        <ul style={tmpStyle} className='popup'>
          <li>
            <a onClick={(e) => btnCreateDirectory(id, padre)}> Crear Carpeta </a>
          </li>
          <li>
            <a
              onClick={(e) => btnEditarDirectory(id, padre, idsusuariocompartidos, nombredocumento)}
            >
              {' '}
              Editar Carpeta{' '}
            </a>
          </li>
          <li>
            <a onClick={(e) => btnCreateFile(id, padre)}> Crear Archivo</a>
          </li>
        </ul>
      );
      return menu;
    }
  };
  //#endregion

  //#region metodo de crear directorio
  const btnCreateDirectory = (key, padre) => {
    formModalDirectorio.resetFields();
    //const token: any = jwt_decode(localStorage.getItem('token'));
    // const usr: any = JSON.parse(token.data);
    // var listUsuarioPartidos = [];
    // console.log(listAprobadoresAutoComplete);
    // if (usr !== undefined) {
    //     listUsuarioPartidos.push(usr.Id);

    //     //setListdefaultValueCompartidoCon(listUsuario);
    // }
    formModalDirectorio.setFieldsValue({
      key: key,
      padre: padre
      //compartircon: listUsuarioPartidos
    }); //seteamos el
    setTitleDirectorio('Crear Directorio');
    setShowContainerFile(false);
    setIsModalCrearDirectorioVisible(true);
  };
  const btnEditarDirectory = (key, padre, idsusuariocompartidos, nombredocumento) => {
    formModalDirectorio.resetFields();
    var listUsuarioPartidos = [];
    if (idsusuariocompartidos !== '') {
      listUsuarioPartidos = idsusuariocompartidos.split(',').map((x) => {
        return parseInt(x);
      });
      //setListdefaultValueCompartidoCon(listUsuarioPartidos);
    }
    formModalDirectorio.setFieldsValue({
      accion: 'actualizar',
      key: key,
      padre: padre,
      nombre: nombredocumento,
      compartircon: listUsuarioPartidos
    }); //seteamos el
    setTitleDirectorio('Editar Directorio');
    setShowContainerFile(false);
    setIsModalCrearDirectorioVisible(true);
  };

  const onSubmitModalCrearDirectorioOk = useCallback(async (values, listTree) => {
    /*Obtenedemos el objeto generado en el arbol */

    var entidad = getObjectGenerateNodeInTree(
      values.getFieldValue('key'),
      {
        title: values.getFieldValue('nombredocumento'),
        key: ''
      },
      listTree
    );
    const request = new FormData();
    request.append('id', '0');
    if (values.getFieldValue('compartircon') !== undefined)
      request.append('listcompartircon', values.getFieldValue('compartircon').join(','));
    // request.append('soloyo', validarGusto.toString());
    request.append('padre', values.getFieldValue('padre'));
    request.append('nombredocumento', values.getFieldValue('nombre'));
    request.append('keytree', entidad.key);
    request.append('icontree', 'false');

    if (values.getFieldValue('accion') === 'actualizar') {
      const res: any = await gestionDocumentosProvider.Actualizar_Directorio(request);
      if (res.succeeded) {
        message.success('Se actualizo correctamente el directorio');
        await obtenerArchivosTreeView();
      } else message.error('Ocurreo un error al intentar crear el directorio');
    } else {
      const res: any = await gestionDocumentosProvider.Registrar_Actualizar_Archivo(request);
      if (res.succeeded) {
        message.success('Se registro correctamente el directorio');
        await obtenerArchivosTreeView();
      } else message.error('Ocurreo un error al intentar crear el directorio');
    }

    //setAutoExpandParent(false);//descomentar
    formModalDirectorio.resetFields();
    setIsModalCrearDirectorioVisible(false);
  }, []);

  const IsModalCrearDirectorioCancel = useCallback(() => {
    //setListdefaultValueCompartidoCon([]);
    formModalDirectorio.resetFields();
    setIsModalCrearDirectorioVisible(false);
  }, [formModalDirectorio]);
  //#endregion

  //#region metodo de crear file
  const btnCreateFile = (key, padre) => {
    setShowContainerDirectorio(false);
    setisDisabledControlesDocumentos(false);
    setShowContainerFile(true);
    setEstadoDocumento('');
    formFile.resetFields();
    formFile.setFieldsValue({ key: key, padre: padre }); //seteamos el
  };
  const onSubmitCrearFileOk = useCallback(async (values, listTree, adjuntos) => {
    /*Insertamos nodo en el tree */
    const request = new FormData();
    request.append(
      'codigodocumento',
      values.getFieldValue('codigodocumento') === undefined
        ? ''
        : values.getFieldValue('codigodocumento')
    );
    request.append(
      'id',
      values.getFieldValue('id') === undefined ? '0' : values.getFieldValue('id')
    );
    request.append(
      'padre',
      values.getFieldValue('padre') === undefined ? '0' : values.getFieldValue('padre')
    );
    request.append(
      'idaprobador',
      values.getFieldValue('idaprobador') === undefined ? '0' : values.getFieldValue('idaprobador')
    );
    request.append(
      'idcategoria',
      values.getFieldValue('idcategoria') === undefined ? '0' : values.getFieldValue('idcategoria')
    );
    request.append('nombredocumento', values.getFieldValue('nombredocumento'));
    request.append('versiondocumento', values.getFieldValue('versiondocumento'));
    request.append(
      'proceso',
      values.getFieldValue('proceso') === undefined ? '' : values.getFieldValue('proceso')
    );
    request.append(
      'direccion',
      values.getFieldValue('direccion') === undefined ? '' : values.getFieldValue('direccion')
    );
    request.append(
      'area',
      values.getFieldValue('area') === undefined ? '' : values.getFieldValue('area')
    );
    request.append(
      'responsable',
      values.getFieldValue('responsable') === undefined ? '' : values.getFieldValue('responsable')
    );
    request.append(
      'ubicacion',
      values.getFieldValue('ubicacion') === undefined ? '' : values.getFieldValue('ubicacion')
    );
    if (values.getFieldValue('key') !== undefined) {
      /*Se esta registran un archivo desde el arbol */
      /*Obtenedemos el objeto generado en el arbol */
      var entidad = getObjectGenerateNodeInTree(
        values.getFieldValue('key'),
        {
          title: values.getFieldValue('nombredocumento'),
          key: '',
          icon: <FileOutlined />
        },
        listTree
      );
      request.append('keytree', entidad.key);
      request.append('icontree', 'true');
    }
    adjuntos.forEach((file) => {
      request.append('FormFiles', file);
    });
    const res: any = await gestionDocumentosProvider.Registrar_Actualizar_Archivo(request);
    if (res.succeeded) {
      message.success(res.message);
      obtenerArchivosTreeView(); //
    } else {
      message.error('Ocurreo un error al intentar crear el archivo');
    }
    /*Reseteamos el formulario  */
    removeAdjunto(null);
    formFile.resetFields();
    //setAutoExpandParent(false);//descomentar
  }, []);

  const onCancelaCrearFile = useCallback(() => {
    formFile.resetFields();
    setShowContainerFile(false);
  }, [formFile]);

  const onEditFile = async (data) => {
    const res = await gestionDocumentosProvider.ObtenerArchivosPorId({ id: data.id });

    const archivo = res.data[0];
    setIdArchivo(archivo.id);
    setEstadoDocumento(archivo.descripcionEstado);
    if (archivo.estado == 1) {
      //Pendiente
      setisDisabledControlesDocumentos(false);
    } else if (archivo.estado == 2) {
      //Aprobado
      setisDisabledControlesDocumentos(true);
    }
    formFile.setFieldsValue({
      id: archivo.id,
      nombredocumento: archivo.nombredocumento,
      codigodocumento: archivo.codigodocumento,
      versiondocumento: archivo.versiondocumento,
      idcategoria: archivo.idcategoria,
      //idaprobador: archivo.idaprobador === 0 || archivo.idaprobador === null ? null : archivo.idaprobador,
      proceso: archivo.proceso,
      direccion: archivo.direccion,
      area: archivo.area,
      responsable: archivo.responsable,
      ubicacion: archivo.ubicacion
    }); //seteamos el

    if (archivo.idaprobador !== 0) {
      formFile.setFieldsValue({ idaprobador: archivo.idaprobador }); //seteamos el
    }
    /*formFile.setFieldsValue({
            id: data.id,
            nombredocumento: data.nombredocumento,
            codigodocumento: data.codigodocumento,
            versiondocumento: data.versiondocumento,
            idcategoria: data.idcategoria,
            idaprobador: data.idaprobador
        }); //seteamos el   

        */
    setShowContainerDirectorio(false);
    setShowContainerFile(true);
  };

  const onDelFile = (id) => {
    Modal.confirm({
      title: 'GESSOMA',
      content: 'Esta seguro que desea eliminar archivo',
      okText: 'Ok',
      cancelText: 'Cancelar',
      onCancel: () => {},
      onOk: async () => {
        const res = await gestionDocumentosProvider.EliminarArchivosPorId({ id: id });
      }
    });
  };

  //#endregion
  //#region metodo fileunput
  const removeAdjunto = (file) => {
    const index = adjuntos.indexOf(file);
    const newFileList = adjuntos.slice();
    newFileList.splice(index, 1);
    setadjuntos([...newFileList]);
  };
  const beforeAdjunto = (file, files) => {
    setadjuntos(files);
    return false;
  };
  //#endregion

  const loop = (data) =>
    data.map((item) => {
      const index = item.title.indexOf(searchValue);
      const beforeStr = item.title.substr(0, index);
      const afterStr = item.title.substr(index + searchValue.length);
      const title =
        index > -1 ? (
          <span>
            {beforeStr}
            <span className='site-tree-search-value'>{searchValue}</span>
            {afterStr}
          </span>
        ) : (
          <span>{item.title}</span>
        );
      if (item.children) {
        return {
          title,
          key: item.key,
          id: item.id,
          icon: item.icon,
          children: loop(item.children),
          disabled: item.disabled,
          nombredocumento: item.title,
          idsusuariocompartidos: item.idsusuariocompartidos
        };
      }
      return {
        title,
        key: item.key,
        id: item.id,
        icon: item.icon,
        disabled: item.disabled,
        nombredocumento: item.title,
        idsusuariocompartidos: item.idsusuariocompartidos
      };
    });
  function handleMenuClick(e) {
    message.info('Click on menu item.');
    console.log('click', e);
  }
  function handleButtonClick(e) {
    message.info('Click on left button.');
    console.log('click left button', e);
  }
  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key='1' icon={<UserOutlined />}>
        1st menu item
      </Menu.Item>
      <Menu.Item key='2' icon={<UserOutlined />}>
        2nd menu item
      </Menu.Item>
      <Menu.Item key='3' icon={<UserOutlined />}>
        3rd menu item
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {getNodeTreeRightClickMenu()}
      <Card title={'Registro de Documentos'}>
        <div className='row'>
          <div className='col-md-4'>
            <div className='container-tree'>
              {/* <Dropdown.Button size={"small"} onClick={handleButtonClick} overlay={menu}>
                                Seleccione
                            </Dropdown.Button>
                            <br />
                            <br /> */}
              <Search style={{ marginBottom: 8 }} placeholder='Buscar...' onChange={onChangeTree} />
              <DirectoryTree
                onExpand={onExpand}
                autoExpandParent={autoExpandParent}
                expandedKeys={expandedKeys}
                onSelect={onSelect}
                treeData={loop(listTree)}
                onRightClick={onRightClick}
              />
            </div>
          </div>
          <div className='col-md-7'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='row' style={{ display: showContainerDirectorio ? 'flex' : 'none' }}>
                  {listDocumentos.map((p, index) => {
                    var listActions = [];
                    listActions.push(
                      <Button type='link' onClick={() => onEditFile(p)}>
                        {' '}
                        <EditOutlined key='edit' />
                      </Button>
                    );
                    listActions.push(
                      <Button type='link' onClick={() => onDelFile(p.id)}>
                        <DeleteOutlined key='edit' />
                      </Button>
                    );
                    if (p.totaladjuntos > 0) {
                      listActions.push(
                        <Button type='link' onClick={() => descargar(p)}>
                          <DownloadOutlined key='edit' />
                        </Button>
                      );
                    }
                    var strfile = '';
                    if (p.extension.split(',').length === 1) {
                      switch (p.extension.split(',')[0]) {
                        case '.docx':
                          strfile = './icons/icon_word.png';
                          break;
                        case '.png':
                          strfile = './icons/icon_imagen.png';
                          break;
                        case '.txt':
                          strfile = './icons/icon_txt.png';
                          break;
                        case '.xlsx':
                          strfile = './icons/icon_excel.png';
                          break;
                        default:
                          strfile = './icons/icon_file.png';
                          break;
                      }
                    } else if (p.extension.split(',').length > 1) {
                      strfile = './icons/icon-multifiles.png';
                    }
                    return (
                      <div className='col-md-3'>
                        <Card
                          key={index}
                          style={{ width: 160, height: 240 }}
                          cover={
                            <img
                              alt='example'
                              src={strfile}
                              //src='./content/bg-card-1.jpg'
                            />
                          }
                          actions={listActions}
                        >
                          <Meta title='' description={p.nombredocumento} />
                        </Card>
                      </div>
                    );
                  })}
                </div>
                <div className='row' style={{ display: showContainerFile ? 'flex' : 'none' }}>
                  <div className='col-md-8'>
                    <Form
                      {...formItemLayout}
                      name='register'
                      initialValues={{ remember: true }}
                      form={formFile}
                      onFinish={() => onSubmitCrearFileOk(formFile, listTree, adjuntos)}
                      scrollToFirstError
                    >
                      <Form.Item
                        name='nombredocumento'
                        label='Nombre del doc.'
                        rules={[{ required: true, message: 'Nombre documento es requerido!' }]}
                      >
                        <Input disabled={isDisabledControlesDocumentos} />
                      </Form.Item>
                      <Form.Item name='codigodocumento' label='Codigo del doc.'>
                        <Input disabled={isDisabledControlesDocumentos} />
                      </Form.Item>
                      <Form.Item
                        name='versiondocumento'
                        label='Version del doc.'
                        rules={[{ required: true, message: 'Version documento es requerido!' }]}
                      >
                        <Input disabled={isDisabledControlesDocumentos} />
                      </Form.Item>

                      <Form.Item name='proceso' label='Proceso.'>
                        <Input disabled={isDisabledControlesDocumentos} />
                      </Form.Item>

                      <Form.Item name='direccion' label='Direccion.'>
                        <Input disabled={isDisabledControlesDocumentos} />
                      </Form.Item>
                      <Form.Item name='area' label='Area.'>
                        <Input disabled={isDisabledControlesDocumentos} />
                      </Form.Item>
                      <Form.Item name='responsable' label='Responsable.'>
                        <Input disabled={isDisabledControlesDocumentos} />
                      </Form.Item>
                      <Form.Item name='ubicacion' label='Ubicación.'>
                        <Input disabled={isDisabledControlesDocumentos} />
                      </Form.Item>
                      <Form.Item name='idcategoria' label='Categoria'>
                        <Select disabled={isDisabledControlesDocumentos}>
                          {listCategoria.map((p, index) => {
                            return (
                              <Option key={index} value={p.idvalor}>
                                {p.descripcionvalor}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item name='idaprobador' label='Solicitar aprob. de'>
                        <Select disabled={isDisabledControlesDocumentos}>
                          {listAprobadores.map((p, index) => {
                            return (
                              <Option key={index} value={p.usuarioId}>
                                {p.nombreCompleto}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item label='key' name='key' noStyle>
                        <Input type='hidden' />
                      </Form.Item>
                      <Form.Item label='padre' name='padre' noStyle>
                        <Input type='hidden' />
                      </Form.Item>
                      <Form.Item label='id' name='id' noStyle>
                        <Input type='hidden' />
                      </Form.Item>
                    </Form>
                  </div>
                  <div className='col-md-4'>
                    <div
                      className='row'
                      style={{ display: estadoDocumento !== '' ? 'flex' : 'none' }}
                    >
                      <div className='col-md-12'>
                        <label className='estadoDocumento'>{estadoDocumento}</label>
                      </div>
                    </div>
                    <br />
                    <div className='row'>
                      <div className='col-md-12'>
                        <Form.Item>
                          <Upload
                            disabled={isDisabledControlesDocumentos}
                            multiple
                            fileList={adjuntos}
                            listType='text'
                            onRemove={removeAdjunto}
                            beforeUpload={beforeAdjunto}
                            className='upload-list-inline'
                          >
                            <Button
                              disabled={isDisabledControlesDocumentos}
                              type={'link'}
                              icon={<UploadOutlined />}
                            >
                              Subir archivo
                            </Button>
                          </Upload>
                        </Form.Item>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <Row justify={'center'}>
                          <Col>
                            <Form.Item>
                              <Space size={'middle'}>
                                <Button
                                  type='primary'
                                  block
                                  onClick={formFile.submit}
                                  disabled={isDisabledControlesDocumentos}
                                >
                                  Registrar
                                </Button>
                                <Button type='default' onClick={onCancelaCrearFile}>
                                  Cancelar
                                </Button>
                                {idArchivo !== 0 ? (
                                  <Button type='primary' onClick={() => onVerHistorial(formFile)}>
                                    Historial
                                  </Button>
                                ) : null}
                              </Space>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
      <Modal
        title={titleDirectorio}
        visible={isModalCrearDirectorioVisible}
        onOk={formModalDirectorio.submit}
        onCancel={IsModalCrearDirectorioCancel}
        okText='Guardar'
        cancelText='Cancelar'
      >
        <div className='row'>
          <div className='col-md-12'>
            <Form
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              form={formModalDirectorio}
              onFinish={() => onSubmitModalCrearDirectorioOk(formModalDirectorio, listTree)}
              autoComplete='off'
            >
              <Form.Item
                label='Nombre'
                name='nombre'
                rules={[{ required: true, message: 'Nombre directorio es requerido!' }]}
              >
                <Input />
              </Form.Item>
              <Form.Item label='Visible para' name='compartircon'>
                <Select mode='multiple' placeholder='Compartir con' style={{ width: '100%' }}>
                  {listAprobadoresAutoComplete}
                </Select>
              </Form.Item>
              <Form.Item label='key' name='key' noStyle>
                <Input type='hidden' />
              </Form.Item>
              <Form.Item label='padre' name='padre' noStyle>
                <Input type='hidden' />
              </Form.Item>
              <Form.Item label='accion' name='accion' noStyle>
                <Input type='hidden' />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>
      <Modal
        title='Historial de Documentos'
        visible={isModalHistorialDocumentosVisible}
        width={1000}
        closable={false}
        footer={[
          <Button key='submit' type='default' onClick={IsModalHistorialDocumentoCancel}>
            Cancelar
          </Button>
        ]}
      >
        <div className='row'>
          <div className='col-md-12'>
            <Table
              locale={{ emptyText: 'No existen registros' }}
              pagination={false}
              columns={columns}
              dataSource={data.data}
              bordered
            />
            <Row justify={'center'}>
              <Col>
                <PaginacionPersonalizada
                  total={data.totalRecords}
                  current={current}
                  onChange={setCurrent}
                />
              </Col>
            </Row>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default GestionRegDocumentos;
